import "core-js/modules/es.array.push.js";
import { ref, shallowRef } from '@vue/reactivity';
import AMapLoader from '@amap/amap-jsapi-loader';
import Config from '@/config';
import SessionUtil from '@/utils/SessionUtil.js';
import AssetsUtil from '@/utils/AssetsUtil';
import CommonUtil from '../../../../utils/CommonUtil';
import { showConfirmDialog, showDialog } from 'vant';
import RouterUtil from '@/utils/RouterUtil';
import GeocoderUtil from '@/utils/GeocoderUtil';
import moment from 'moment/moment';
import TipForm from '@/view/components/tip-form/tip-form.vue';
import StorageUtil from '@/utils/StorageUtil';
import OrderApi from '@/api/order-api';
import SettingApi from '@/api/setting-api';
export default {
  name: 'OrderCalling',
  components: {
    TipForm
  },
  computed: {
    CommonUtil() {
      return CommonUtil;
    }
  },
  setup() {
    const noQueryAddress = ref(false);
    const map = shallowRef();
    const geolocation = shallowRef();
    const geocoder = shallowRef();
    const weather = shallowRef();
    const driving = shallowRef();
    const vehicleTypes = ref();
    const vehiclePrices = ref({
      'ORDER_CAR_TYPE_NORMAL_TAXI': 0,
      'ORDER_CAR_TYPE_ONLINE_TAXI': 0
    });
    const vehicleTypeCheckedCount = ref(0);
    const vehicleTypeUnCheckedCount = ref(0);
    const position = ref(Config.defaultPosition);
    const cityName = ref('');
    const cityCode = ref('');
    const lastCityCode = ref('');
    const showWeather = ref(false);
    const cityWeather = ref('');
    const cityWeatherIcon = ref(require('@/assets/icon/weather/default.svg'));
    const startAddress = ref('');
    const startPosition = ref([]);
    const endAddress = ref('您要去哪里？');
    const endPosition = ref([]);
    const kilometer = ref('--');
    const drivingTime = ref('--');
    const reserveDay = ref(0);
    const reserveTime = ref(['12', '00']);
    const paidPickUp = ref(false);
    const tip = ref(false);
    const showTipForm = ref(false);
    const tipAmount = ref();
    const tolls = ref(0);
    const callLevel = ref(1);
    const callErrorCount = ref(0);
    const forceCancel = ref(false);
    const waitTime = ref('--');
    const waitTimeInterval = ref(null);
    const refreshStatusInterval = ref();
    const orderType = ref(null);
    const orderInitiateData = ref(null);
    const callingData = ref(null);
    const setting = ref(null);
    const isMorningRushHour = ref(false);
    const isEveningRushHour = ref(false);
    return {
      noQueryAddress,
      map,
      geolocation,
      geocoder,
      vehicleTypes,
      vehiclePrices,
      vehicleTypeCheckedCount,
      vehicleTypeUnCheckedCount,
      weather,
      driving,
      position,
      cityName,
      cityCode,
      lastCityCode,
      showWeather,
      cityWeather,
      cityWeatherIcon,
      startAddress,
      startPosition,
      endAddress,
      endPosition,
      kilometer,
      drivingTime,
      reserveDay,
      reserveTime,
      paidPickUp,
      tip,
      showTipForm,
      tipAmount,
      tolls,
      callLevel,
      callErrorCount,
      forceCancel,
      waitTime,
      waitTimeInterval,
      refreshStatusInterval,
      orderType,
      orderInitiateData,
      callingData,
      setting,
      isMorningRushHour,
      isEveningRushHour
    };
  },
  mounted() {
    const that = this;
    that.getUndoneOrder();
    that.getWaitDispatchOrder();
    SettingApi.getSetting().then(function (result) {
      if (result.setting) {
        that.setting = result.setting;
      }
    });
    // //早晚高峰判断时间
    // const peakHoursDate = new Date();
    // //判断是否为早高峰
    // this.isMorningRushHour = (peakHoursDate.getHours() === 7)
    //   || (peakHoursDate.getHours() === 8 && peakHoursDate.getMinutes() <= 30);
    // //判断是否为晚高峰
    // this.isEveningRushHour = (peakHoursDate.getHours() === 16 && peakHoursDate.getMinutes() >= 30)
    //   || (peakHoursDate.getHours() === 17 && peakHoursDate.getMinutes() <= 30);
    // this.vehicleTypes = [
    //   {
    //     icon: require('@/assets/icon/vehicle/taxi.png'),
    //     name: '出租车', description: '传统出租 接单快速', pricePrefix: '预估',
    //     discount: 1.0,
    //     checked: true,
    //     disabled: false
    //   },
    //   {
    //     icon: require('@/assets/icon/vehicle/taxi-new.png'),
    //     name: '新出租', description: '网约价格 超值畅行', pricePrefix: '预估',
    //     discount: 0.9,
    //     checked: true,
    //     disabled: false
    //   }
    // ];
    // if (this.isMorningRushHour || this.isEveningRushHour) {
    //   this.vehicleTypes[0].checked = true;
    //   this.vehicleTypes[1].checked = false;
    //
    //   this.vehicleTypes[0].disabled = false;
    //   this.vehicleTypes[1].disabled = true;
    // }
    this.calculateVehicleTypeCheck();
    try {
      this.orderInitiateData = StorageUtil.getObject('orderInitiateData');
      if (this.orderInitiateData) {
        this.startAddress = this.orderInitiateData.startAddress;
        this.startPosition = this.orderInitiateData.startPosition;
        this.endAddress = this.orderInitiateData.endAddress;
        this.endPosition = this.orderInitiateData.endPosition;
        this.position = this.startPosition;
      }
      this.callingData = StorageUtil.getObject('callingData');
      if (this.callingData) {
        this.vehicleTypes = this.callingData.vehicles.types;
        if (this.callingData.vehicles) {
          this.vehiclePrices = this.callingData.vehicles.prices;
        }
        this.paidPickUp = this.callingData.paidPickUp;
        this.tip = this.callingData.tip;
        this.tipAmount = this.callingData.tipAmount;
        this.tolls = this.callingData.tolls;
        this.calculateVehicleTypeCheck();
      }
    } catch (e) {
      console.log(e);
    } finally {
      // StorageUtil.remove("orderInitiateData");
      setTimeout(function () {
        //DOM初始化完成进行地图初始化
        that.initMap();
      }, 250);
    }
    this.waitTime = 0;
    clearInterval(this.waitTimeInterval);
    this.waitTimeInterval = setInterval(function () {
      var _that$setting, _that$setting2;
      if ((_that$setting = that.setting) !== null && _that$setting !== void 0 && _that$setting.waitingTimeout && that.waitTime > ((_that$setting2 = that.setting) === null || _that$setting2 === void 0 ? void 0 : _that$setting2.waitingTimeout) * 60) {
        clearInterval(this.waitTimeInterval);
        showDialog({
          message: '很抱歉，暂时没有司机应答，您可重新叫车'
        }).then(function () {
          that.doCancelOrder(true);
        });
      } else {
        that.waitTime++;
        if (that.waitTime >= 20 && that.waitTime < 40) {
          that.callLevel = 2;
        }
        if (that.waitTime >= 40) {
          that.callLevel = 3;
        }
        if (that.waitTime / 60 > 5) {
          clearInterval(that.waitTimeInterval);
          showDialog({
            message: '当前订单等待时间过长，请重新叫车',
            confirmButtonText: '取消订单'
          }).then(() => {
            that.forceCancel = true;
            that.cancelOrder();
          });
        }
      }
    }, 1000);
    this.refreshStatusInterval = setInterval(function () {
      that.getUndoneOrder();
    }, 1000);
  },
  deactivated() {
    clearInterval(this.refreshStatusInterval);
    clearInterval(this.waitTimeInterval);
  },
  unmounted() {
    clearInterval(this.refreshStatusInterval);
    clearInterval(this.waitTimeInterval);
    if (this.map) {
      this.map.destroy();
    }
  },
  methods: {
    initMap() {
      const that = this;
      window._AMapSecurityConfig = {
        securityJsCode: '23ca323d154479c363c8c8df0b1ddb92'
      };
      AMapLoader.load({
        key: Config.mapKey,
        // 申请好的Web端开发者Key，首次调用 load 时必填
        version: Config.mapVersion,
        // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [
        // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        'AMap.Geocoder', 'AMap.Geolocation', 'AMap.Weather', 'AMap.Driving']
      }).then(AMap => {
        this.map = new AMap.Map('map', {
          //设置地图容器ID
          viewMode: '2D',
          //是否为3D地图模式
          zoom: Config.defaultMapZoom,
          //初始化地图级别
          center: this.position,
          //初始化地图中心点位置
          // mapStyle: "amap://styles/macaron",   //地图样式
          dragEnable: false
        });
        this.geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,
          //是否使用高精度定位，默认:true
          timeout: 10000,
          //超过10秒后停止定位，默认：5s
          //position: 'RB',                         //定位按钮的停靠位置
          //offset: [10, 20],                       //定位按钮与设置的停靠位置的偏移量，默认：[10, 20]
          zoomToAccuracy: true //定位成功后是否自动调整地图视野到定位点
        });
        this.geocoder = new AMap.Geocoder({
          // city: "010",                            //城市设为北京，默认：“全国”
          // radius: 1000                            //范围，默认：500
        });
        this.weather = new AMap.Weather();
        this.driving = new AMap.Driving({
          map: this.map
          //驾车策略，包括 LEAST_TIME，LEAST_FEE, LEAST_DISTANCE,REAL_TRAFFIC
          // policy: AMap.DrivingPolicy.LEAST_TIME,
          // autoFitView: false,
          // panel: "panel"
        });
        this.map.on('moveend', function () {
          that.position = that.map.getCenter();
          if (!that.noQueryAddress) {
            that.getAddress(that.position);
          }
          that.noQueryAddress = false;
        });
        this.getAddress(this.position);
        this.getCurrentPosition();
      }).catch(e => {
        console.error(e);
      });
    },
    getCurrentPosition() {
      const that = this;
      try {
        this.geolocation.getCurrentPosition(function (status, result) {
          if (status === 'complete') {
            that.position = result.position;
          } else {
            that.position = Config.defaultPosition;
          }
          that.getAddress(that.position);
        });
      } catch (e) {
        that.position = Config.defaultPosition;
        that.getAddress(that.position);
      }
    },
    getAddress(position) {
      const that = this;
      this.geocoder.getAddress(position, function (status, result) {
        if (status === 'complete' && result.regeocode) {
          const addressComponent = result.regeocode.addressComponent;
          // const formattedAddress = result.regeocode.formattedAddress;
          // const showAddress = formattedAddress
          //   .replace(addressComponent.province, '')
          //   .replace(addressComponent.city, '')
          //   .replace(addressComponent.district, '')
          //   .replace(addressComponent.township, '');
          // console.error(showAddress);
          that.cityCode = addressComponent.adcode;
          that.cityName = addressComponent.district.length > 0 && (addressComponent.district.indexOf('市') > 0 || addressComponent.district.indexOf('县') > 0) ? addressComponent.district : addressComponent.city;
          if (that.cityCode !== that.lastCityCode) {
            that.getWeather(that.cityCode);
          }
          that.lastCityCode = that.cityCode;
          if (that.cityName.length < 1) {
            that.cityName = '未知地区';
          }
        } else {
          that.cityName = '未知地区';
          console.error('根据经纬度查询地址失败：' + status);
        }
      });
    },
    getWeather(cityCode) {
      const that = this;
      that.weather.getLive(cityCode, function (err, data) {
        if (!err) {
          if (data.weather && data.temperature) {
            that.showWeather = true;
            that.cityWeather = data.temperature + '℃';
            that.cityWeatherIcon = AssetsUtil.getWeatherIcon(data.weather);
          } else {
            that.showWeather = false;
          }
        } else {
          that.showWeather = false;
        }
      });
    },
    getDriving() {
      const that = this;
      this.driving.search(this.startPosition, this.endPosition, function (status, result) {
        // result 即是对应的驾车导航信息，相关数据结构文档请参考：https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
        if (status === 'complete') {
          if (result.routes) {
            const routes = result.routes;
            if (routes.length > 0) {
              const route = routes[0];
              const distance = parseFloat(route.distance);
              that.tolls = parseFloat(route.tolls);
              that.kilometer = parseFloat(distance / 1000.00);
              that.drivingTime = route.time;
              that.$forceUpdate();
            }
          }
        } else {
          console.error('获取驾车数据失败：' + result);
        }
      });
    },
    selectPaidPickUp() {
      if (!this.paidPickUp) {
        showConfirmDialog({
          message: '您确定需要打表来接吗？'
        }).then(() => {
          this.paidPickUp = true;
          this.doReCall();
        }).catch(() => {
          this.paidPickUp = false;
        });
      } else {
        this.paidPickUp = false;
      }
    },
    checkVehicleType(index) {
      if (this.vehicleTypes[index].checked) {
        return;
      }
      this.vehicleTypes[index].checked = !this.vehicleTypes[index].checked;
      this.calculateVehicleTypeCheck();
      this.$forceUpdate();
      this.doReCall();
    },
    goAddress(type) {
      StorageUtil.setObject('positionData', {
        type: type,
        position: this.position
      });
      this.$router.push('/address');
    },
    goBack() {
      StorageUtil.setObject('addressData', {
        type: 'end',
        address: '',
        position: ''
      });
      RouterUtil.back();
    },
    calculateVehicleTypeCheck() {
      if (this.vehicleTypes && this.vehicleTypes.length) {
        this.vehicleTypeCheckedCount = 0;
        this.vehicleTypeUnCheckedCount = 0;
        for (let i = 0; i < this.vehicleTypes.length; i++) {
          const vehicleType = this.vehicleTypes[i];
          if (vehicleType.checked) {
            this.vehicleTypeCheckedCount++;
          } else {
            this.vehicleTypeUnCheckedCount++;
          }
        }
      }
    },
    getVehicleType() {
      if (this.vehicleTypes) {
        let vt1 = this.vehicleTypes['ORDER_CAR_TYPE_NORMAL_TAXI'].checked;
        let vt2 = this.vehicleTypes['ORDER_CAR_TYPE_ONLINE_TAXI'].checked;
        if (!vt1 && !vt2) {
          return null;
        }
        if (vt1 && !vt2) {
          return 'ORDER_CAR_TYPE_NORMAL_TAXI';
        }
        if (!vt1 && vt2) {
          return 'ORDER_CAR_TYPE_ONLINE_TAXI';
        }
        if (vt1 && vt2) {
          return 'ORDER_CAR_TYPE_NORMAL_TAXI,ORDER_CAR_TYPE_ONLINE_TAXI';
        }
      } else {
        return null;
      }
    },
    getEstimatePrice() {
      if (this.vehicleTypes['ORDER_CAR_TYPE_NORMAL_TAXI'].checked) {
        return this.vehiclePrices['ORDER_CAR_TYPE_NORMAL_TAXI'];
      }
      return 0;
    },
    tipCancelClick() {
      this.tip = false;
      this.showTipForm = false;
    },
    tipEnterClick(amount) {
      this.tipAmount = amount;
      this.tip = true;
      this.showTipForm = false;
    },
    clickShowTipForm() {
      this.showTipForm = !this.showTipForm;
    },
    getUndoneOrder() {
      const that = this;
      OrderApi.getProgressOrder().then(function (result) {
        if (result.success && result.orderData) {
          StorageUtil.setObject('orderData', result.orderData);
          that.$router.replace('/order/progress');
        }
      });
    },
    getWaitDispatchOrder() {
      const that = this;
      OrderApi.getWaitDispatchOrder().then(function (result) {
        if (result.success) {
          const order = result.orderData;
          const vehicleTypes = {
            'ORDER_CAR_TYPE_NORMAL_TAXI': {
              icon: require('@/assets/icon/vehicle/taxi.png'),
              name: '出租车',
              description: '传统出租 接单快速',
              pricePrefix: '预估',
              discount: 1.0,
              checked: order.order_car_types.indexOf('ORDER_CAR_TYPE_NORMAL_TAXI') !== -1
            },
            'ORDER_CAR_TYPE_ONLINE_TAXI': {
              icon: require('@/assets/icon/vehicle/taxi-new.png'),
              name: '新出租',
              description: '线上价格 超值畅行',
              pricePrefix: '预估',
              discount: 0.9,
              checked: order.order_car_types.indexOf('ORDER_CAR_TYPE_ONLINE_TAXI') !== -1
            }
          };
          const startPosition = [order.departure_address_longitude, order.departure_address_latitude];
          const endPosition = [order.destination_address_longitude, order.destination_address_latitude];
          const callVehicleTime = CommonUtil.toDate(order.car_calling_time, 'YYYY-MM-DD HH:mm:ss');
          const reserveDateTime = CommonUtil.toDate(order.car_usage_time, 'YYYY-MM-DD HH:mm:ss');
          const reserveDate = CommonUtil.formatDate(reserveDateTime, 'YYYY-MM-DD');
          const reserveTime = CommonUtil.formatDate(reserveDateTime, '[HH:mm]');
          const reserveDay = parseInt(CommonUtil.formatDate(reserveDateTime, 'DD')) - parseInt(CommonUtil.formatDate(new Date(), 'DD'));
          that.orderType = order.order_type;
          that.waitTime = (new Date().getTime() - callVehicleTime.getTime()) / 1000;
          that.orderInitiateData = {
            startAddress: order.departure_address,
            startPosition: startPosition,
            endAddress: order.destination_address,
            endPosition: endPosition,
            reserve: order.order_type === 'ORDER_TYPE_RESERVATION',
            reserveDay: reserveDay,
            reserveDate: reserveDate,
            reserveTime: reserveTime,
            proxy: order.behalf_of === 1,
            proxyPriorityContactPassenger: order.behalf_of_first_contact === 1,
            proxyPassengerMobile: order.behalf_of_passenger_phone_number,
            proxyPassengerName: order.behalf_of_passenger_name
          };
          that.callingData = {
            order_id: order.order_number,
            reserve: order.order_type === 'ORDER_TYPE_RESERVATION',
            reserveDate: reserveDate,
            customerPhone: order.passenger_phone_number,
            paidPickUp: order.paid_pick_up === 1,
            tip: order.dispatch_fee > 0,
            tipAmount: order.dispatch_fee,
            vehicles: {
              types: vehicleTypes,
              prices: []
            }
          };
          if (that.orderInitiateData) {
            that.startAddress = that.orderInitiateData.startAddress;
            that.startPosition = that.orderInitiateData.startPosition;
            that.endAddress = that.orderInitiateData.endAddress;
            that.endPosition = that.orderInitiateData.endPosition;
          }
          if (that.callingData) {
            that.vehicleTypes = that.callingData.vehicles.types;
            if (that.callingData.vehicles) {
              that.vehiclePrices = that.callingData.vehicles.prices;
            }
            that.paidPickUp = that.callingData.paidPickUp;
            that.tip = that.callingData.tip;
            that.tipAmount = that.callingData.tipAmount;
            that.calculateVehicleTypeCheck();
          }
          OrderApi.getFuturePrices('NORMAL_ORDER', {
            orderBeginAddressLongitude: startPosition[0],
            orderBeginAddressLatitude: startPosition[1],
            orderTargetAddressLongitude: endPosition[0],
            orderTargetAddressLatitude: endPosition[1]
          }).then(function (result) {
            // if (result.data) {
            //   const tolls = 0;
            //   for (let i = 0; i < result.data.data.length; i++) {
            //     const futureData = result.data.data[i];
            //     that.vehiclePrices[futureData.type] = futureData.cost + tolls;
            //   }
            // }
            const tolls = 0;
            if (result.data) {
              // for (let i = 0; i < result.data.data.length; i++) {
              //   const futureData = result.data.data[i];
              //   that.vehiclePrices[futureData.type] = futureData.cost + tolls;
              // }
              that.vehiclePrices['ORDER_CAR_TYPE_NORMAL_TAXI'] = result.data.data[0].cost + tolls;
              that.$forceUpdate();
            }
          });
        } else {
          RouterUtil.home(true);
        }
      }).catch(function (error) {
        console.error(error);
        RouterUtil.home(true);
      });
    },
    doReCall() {
      const that = this;
      //取消之前订单
      OrderApi.cancelOrder(that.callingData.order_id, '').then(function (result) {
        if (!result.success) {
          return;
        }

        //重新叫车
        const startPosition_BD09 = GeocoderUtil.GCJ02_BD09(that.startPosition[0], that.startPosition[1]);
        const endPosition_BD09 = GeocoderUtil.GCJ02_BD09(that.endPosition[0], that.endPosition[1]);
        OrderApi.submitOrder({
          // customerId: that.userData.id,
          chargeType: 0,
          cleaningCost: 0,
          commentQuality: 0,
          couponDenomination: 0,
          couponId: '',
          couponPrice: 0,
          customerId: SessionUtil.getUserData('id'),
          discountPrice: 0,
          discountRate: 0,
          driverQuality: 0,
          expectCost: that.getEstimatePrice(),
          expectDistance: that.kilometer,
          expectDurationTime: 0,
          hightBridgeCost: 0,
          orderBeginAddress: that.startAddress,
          orderBeginAddressDetail: that.startAddress,
          orderBeginAddressLatitude: startPosition_BD09[1] * Math.pow(10, 6),
          orderBeginAddressLongitude: startPosition_BD09[0] * Math.pow(10, 6),
          orderCarTypeId: '6a542a8698f4485d861a36559505f980',
          orderCarTypeName: '出租车',
          orderIsAllowU: 0,
          orderSmallChange: 0,
          orderTargetAddress: that.endAddress,
          orderTargetAddressDetail: that.endAddress,
          orderTargetAddressLatitude: endPosition_BD09[1] * Math.pow(10, 6),
          orderTargetAddressLongitude: endPosition_BD09[0] * Math.pow(10, 6),
          orderType: that.callingData.reserve ? 'ORDER_TYPE_RESERVATION' : 'ORDER_TYPE_REALTIME',
          otherCost: 0,
          packageFixPrice: 0,
          packageKm: 0,
          packageMinute: 0,
          packageOutKmPrice: 0,
          packageOutMinutePrice: 0,
          parkingCost: 0,
          passengerName: '匿名',
          passengerPhone: that.callingData.customerPhone,
          realBeginAddressLatitude: 0,
          realBeginAddressLongitude: 0,
          realCostTotal: 0,
          realDistance: 0,
          realDurationTime: 0,
          realEndAddressLatitude: 0,
          realEndAddressLongtidute: 0,
          realPayTotal: 0,
          // useCarTime: moment().format("yyyy-MM-DD HH:mm:ss"),
          useCarTime: that.callingData.reserve ? that.callingData.reserveDate + ' ' + that.reserveTime[0] + ':' + that.reserveTime[1] + ':00' : moment().format('yyyy-MM-DD HH:mm:ss'),
          walletAccountId: '',
          orderCarType: that.getVehicleType(),
          functionType: that.paidPickUp ? 1 : 0,
          dispatchFee: that.tip ? that.tipAmount : undefined
        }).then(function (result) {
          if (result.order_id) {
            that.callingData.order_id = result.order_id;
          }
        }).catch(function () {
          that.callErrorCount++;
          if (that.callErrorCount < 5) {
            showDialog({
              message: '叫车请求失败，请重试'
            });
          } else {
            showDialog({
              message: '叫车请求失败多次，请稍后重试或联系客服'
            });
          }
        }).finally(function () {
          that.calling = false;
        });
      });
    },
    cancelOrder() {
      const that = this;
      if (that.forceCancel) {
        that.doCancelOrder();
      } else {
        showConfirmDialog({
          message: '确定要取消订单吗？',
          confirmButtonText: '确定'
        }).then(() => {
          that.doCancelOrder();
        }).catch(() => {
          // on cancel
        });
      }
    },
    doCancelOrder(goInitiate) {
      const that = this;
      OrderApi.cancelOrder(that.callingData.order_id, '').then(function (result) {
        StorageUtil.setObject('addressData', {
          type: 'end',
          address: '',
          position: ''
        });
        if (goInitiate && StorageUtil.contains('orderInitiateData')) {
          RouterUtil.go('/order/initiate');
        } else {
          RouterUtil.home();
        }
      }).finally(function () {
        that.forceCancel = false;
      });
    }
  }
};